import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    token: null,
    twoFaToken: null,
    webToken: null,
  },
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setToken: (state, { payload }) => {
      state.token = payload;
    },
    setTwoFaToken: (state, { payload }) => {
      state.twoFaToken = payload;
    },
    clearTwoFaToken: (state) => {
      state.twoFaToken = null;
    },
    clearToken: (state) => {
      state.token = null;
    },
    setWebToken: (state, { payload }) => {
      state.webToken = payload;
    },
  },
});

// Actions clearTwoFaToken
export const { logoutSuccess, setUser, clearUser, setToken, clearToken, setWebToken, setTwoFaToken, clearTwoFaToken } =
  slice.actions;

export default slice.reducer;
